type ProfilerItem = {
    name: string,
    start: Date,
    end: Date | null
};

const profilerItems = new Map<string, ProfilerItem>();

export const Profiler = {
    start: (name: string) => {
        if (profilerItems.has(name)) {
            return console.error(`Profiler with name ${name} already exists`);
        }
        profilerItems.set(name, { name, start: new Date(), end: null });
        console.info(`[PROFILER] ${name} started`);
    },
    end: (name: string) => {
        const profile = profilerItems.get(name);
        if (!profile) {
            return console.error(`Profiler with name ${name} does not exist`);
        }
        profilerItems.delete(name);
        profile.end = new Date();
        const timeTook = profile.end.getTime() - profile.start.getTime();
        console.info(`[PROFILER] ${name} took ${timeTook}ms`);
    },
};
